<template>
  <div class="page">
    <van-form ref="formRef">
      <div class="group_1">
        <div class="box_1">
          <!-- 头像上传 -->
          <div class="avater" @click="chooseAvatar">
            <span class="text_1">头像</span>
            <span style="display: flex; align-items: center">
              <img :src="userInfo.userphoto" alt="头像" class="avater_1" v-if="userInfo.userphoto!=''&&userInfo.userphoto!=null"/>
              <img src="../assets/new/avater.png" alt="头像" class="avater_1" v-else/>
              <van-icon name="arrow" />
            </span>
            <input type="file" accept="image/*" ref="fileInput" @change="handleFileChange" style="display: none" />
          </div>

          <!-- 用户名 -->
          <van-field
            v-model="userInfo.userName"
            label="用户名"
            input-align="right"
            placeholder="请输入用户名"
            readonly
            error-message-align="right"
          />

          <!-- 姓名 -->
          <van-field v-model="userInfo.realname" label="姓名" readonly input-align="right" error-message-align="right" />

          <!-- 身份证号 -->
          <van-field v-model="userInfo.cardno" readonly label="身份证号" input-align="right" error-message-align="right" />

          <!-- 性别 -->
          <van-field
            v-model="userInfo.sex"
            label="性别"
            input-align="right"
            readonly
            placeholder="请选择性别"
            right-icon="arrow"
            @click="showPicker = true"
            error-message-align="right"
          />
          <van-popup v-model="showPicker" position="bottom">
            <van-picker show-toolbar :columns="genderColumns" @confirm="onGenderConfirm" @cancel="showPicker = false" />
          </van-popup>

          <!-- 手机号码 -->

          <van-field
            v-model="userInfo.mobile"
            label="手机号码"
            readonly
            placeholder="请输入手机号码"
            input-align="right"
            error-message-align="right"
          />

          <!-- 电子邮箱 -->
          <van-field
            v-model="userInfo.email"
            label="电子邮箱"
            input-align="right"
            error-message-align="right"
            readonly
            placeholder="请输入电子邮箱"

            right-icon="arrow"
            @click="gotoUpdate('电子邮箱', 'email', userInfo.email)"
          />
        </div>

        <div class="box_2">
          <!-- 地址：联级选择器 -->
          <van-field
            v-model="userInfo.provinceCity"
            label="地址"
            placeholder="请选择地址"
            input-align="right"
            readonly
            right-icon="arrow"
            error-message-align="right"
            @click="openAddress"
            :rules="[{ required: true, message: '请选择地址' }]"
          />
          <van-popup v-model="showAreaPicker" position="bottom">
            <van-cascader
              active-color="#2A70F2"
              v-model="areaValue"
              title="请选择地址"
              :options="areaList"
              @close="onPopupClose1"
              @finish="onFinishAddress"
              @change="onChange1"
            />
            <!-- <van-area :area-list="areaList" @confirm="onAreaConfirm" @cancel="showAreaPicker = false" /> -->
          </van-popup>

          <!-- 单位名称 -->
          <van-field
            v-model="userInfo.organization"
            readonly
            label="单位名称"
            placeholder="请输入单位名称"
            input-align="right"
            right-icon="arrow"
            @click="gotoUpdate('单位名称', 'organization', userInfo.organization)"
          />

          <!-- 单位地址 -->
          <van-field
            v-model="userInfo.infoAddress"
            readonly
            label="单位地址"
            placeholder="请输入单位地址"
            input-align="right"
            @click="gotoUpdate('单位地址', 'infoAddress', userInfo.infoAddress)"
            right-icon="arrow"
          />
        </div>

        <div class="box_3">
          <!-- 职称 -->
        
          <van-field v-model="userInfo.major" label="职称" input-align="right" readonly right-icon="arrow" @click="openMajor"     placeholder="请选择职称"/>
          <van-popup v-model="showTitlePicker" position="bottom">
            <van-cascader
              active-color="#2A70F2"
              v-model="cascaderValue"
              title="请选择职称"
              :options="titleColumns"
              @close="onPopupClose"
              @finish="onFinish"
              @change="onChange"
            />
            <!-- <van-picker show-toolbar :columns="titleColumns" @confirm="onTitleConfirm" @cancel="showTitlePicker = false" /> -->
          </van-popup>

          <!-- 学历 -->
          <van-field
            v-model="userInfo.degree"
            label="学历"
            placeholder="请选择学历"
            input-align="right"
            readonly
            right-icon="arrow"
            @click="showEducationPicker = true"
          />
          <van-popup v-model="showEducationPicker" position="bottom">
            <van-picker show-toolbar :columns="educationColumns" @confirm="onEducationConfirm" @cancel="showEducationPicker = false" />
          </van-popup>
        </div>
      </div>
    </van-form>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { upload, toPersonalData, doUpdatePerson, toCode, toUserArea } from '../api/my';

export default {
  data() {
    return {
      userInfo: {
        sex: '',
        userphoto:require('../assets/new/avater.png')
      },
      avatarUrl: require('../assets/new/avater.png'),
      showPicker: false,
      showAreaPicker: false,
      showTitlePicker: false,
      showEducationPicker: false,
      cascaderValue: '', //职称
      areaValue: '', //地址
      genderColumns: ['男', '女'], //性别
      titleColumns: [], //职称
      educationColumns: ['大专以下', '大专', '本科', '硕士', '博士', '其他'],
      areaList: []
    };
  },
  created() {
    this.getUser();
  },
  methods: {
    //上传头像
    chooseAvatar() {
      this.$refs.fileInput.click();
    },
    async handleFileChange(event) {
      const file = event.target.files[0];
      const token = localStorage.getItem('token');
      if (!file) return;
      const previewUrl = URL.createObjectURL(file);
      this.avatarUrl = previewUrl;
      const formData = new FormData();
      formData.append('file', file);
      try {
        upload(formData, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }).then(res => {
          console.log(res);
          if (res.data && res.data.code == '200') {
            // this.avatarUrl = res.data.url;
            this.updateUser('userPhoto', res.data.url);
            // this.$utils.showToast('上传成功');
          } else {
            this.$utils.showToast('上传失败');
          }
        });
      } catch (error) {
        console.error('上传出错:', error);
        this.$utils.showToast('上传失败');
      }
    },
    //获取个人资料
    getUser() {
      toPersonalData().then(res => {
        this.userInfo = res.data.data;
      });
    },
    //修改个人资料
    updateUser(type, sValue) {
      const params = {
        type: type,
        sValue: sValue
      };
      doUpdatePerson(params).then(res => {
        if (res.data.code == '200') {
          this.$utils.showToast('修改成功');

          this.userInfo = res.data.data;
        }
      });
    },
    //去修改资料
    gotoUpdate(value, type, single) {
      this.$router.push({
        path: '/updateUser',
        query: {
          name: value,
          type: type,
          value: single
        }
      });
    },
    //修改性别
    onGenderConfirm(value) {
      const sexMapping = {
        男: '01',
        女: '02'
      };
      this.userInfo.sex = value;
      const sexCode = sexMapping[value];
      this.updateUser('sex', sexCode);
      this.showPicker = false;
    },
    //修改地址
    openAddress() {
      this.areaValue = '';
      this.areaList = [];
      this.showAreaPicker = true;
      if (!this.areaList || this.areaList.length === 0) {
        toUserArea({ parent: '52' }).then(res => {
          this.areaList = res.data.data.map(item => ({
            text: item.cityName,
            value: item.codeId,
            children: []
          }));
        });
      }
    },
    onChange1({ value, selectedOptions }) {
      const lastOption = selectedOptions[selectedOptions.length - 1];
      if (!lastOption || lastOption.children?.length > 0) return;
      toUserArea({ parent: value }).then(res => {
        const childNodes = res.data.data.map(item => ({
          text: item.cityName,
          value: item.codeId,
          children: []
        }));

        if (childNodes.length === 0) {
          this.onFinishAddress({ selectedOptions });
          return;
        }
        const findAndUpdateNode = (nodes, targetValue) => {
          for (let node of nodes) {
            if (node.value === targetValue) {
              node.children = childNodes;
              return true;
            }
            if (node.children && findAndUpdateNode(node.children, targetValue)) {
              return true;
            }
          }
          return false;
        };
        findAndUpdateNode(this.areaList, lastOption.value);
      });
    },
    onFinishAddress({ selectedOptions }) {
      const lastLevelCodeNo = selectedOptions[selectedOptions.length - 1]?.value;
      this.showAreaPicker = false;
      this.updateUser('area', lastLevelCodeNo);
      // this.userInfo.provinceCity = selectedOptions.map(opt => opt.text).join('/');
    },
    //关闭地址选择
    onPopupClose1() {
      this.showAreaPicker = false;
      this.areaValue = '';
      this.areaList = [];
    },
    //修改职称
    openMajor() {
      this.cascaderValue = '';
      this.titleColumns = [];
      this.showTitlePicker = true;
      if (!this.titleColumns || this.titleColumns.length === 0) {
        toCode({ parent: '20' }).then(res => {
          this.titleColumns = res.data.data.list.map(item => ({
            text: item.CODE_NAME,
            value: item.CODE_NO,
            children: []
          }));
        });
      }
    },
    onChange({ value, selectedOptions }) {
      const lastOption = selectedOptions[selectedOptions.length - 1];
      if (!lastOption || lastOption.children?.length > 0) return;

      toCode({ parent: value }).then(res => {
        const childNodes = res.data.data.list.map(item => ({
          text: item.CODE_NAME,
          value: item.CODE_NO,
          children: []
        }));

        if (childNodes.length === 0) {
          this.onFinish({ selectedOptions });
          return;
        }
        const findAndUpdateNode = (nodes, targetValue) => {
          for (let node of nodes) {
            if (node.value === targetValue) {
              node.children = childNodes;
              return true;
            }
            if (node.children && findAndUpdateNode(node.children, targetValue)) {
              return true;
            }
          }
          return false;
        };

        findAndUpdateNode(this.titleColumns, lastOption.value);
      });
    },

    onFinish({ selectedOptions }) {
      const lastLevelCodeNo = selectedOptions[selectedOptions.length - 1]?.value;
      this.showTitlePicker = false;
      // this.userInfo.major = selectedOptions.map(opt => opt.text).join('/');
      this.updateUser('major', lastLevelCodeNo);
    },

    //关闭职称选择
    onPopupClose() {
      this.showTitlePicker = false;
      this.cascaderValue = '';
      this.titleColumns = [];
    },

    //修改学历
    onEducationConfirm(value) {
      const degreeMapping = {
        大专以下: '01',
        大专: '02',
        本科: '03',
        硕士: '04',
        博士: '05',
        其他: '09'
      };
      this.userInfo.degree = value;
      const degreeCode = degreeMapping[value];
      this.updateUser('degree', degreeCode);
      this.showEducationPicker = false;
    }
  }
};
</script>

<style lang="less" scoped>
.page {
  height: 100vh;
  background: #f6f8fa;
}
.group_1 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .box_1 {
    padding: 0 15px;
    width: 345px;
    margin-top: 12px;
    min-height: 360px;
    background: #ffffff;
    border-radius: 8px;
    .avater {
      border-bottom: 1px solid #f5f6f7;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .avater_1 {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 8px;
        cursor: pointer;
      }
      .text_1 {
        font-size: 14px;
        color: #646566;
      }
    }
  }
}
.box_2 {
  width: 345px;
  min-height: 140px;
  background: #ffffff;
  border-radius: 8px;
  margin-top: 10px;
  padding: 0 15px;
}
.box_3 {
  width: 345px;
  min-height: 112px;
  background: #ffffff;
  border-radius: 8px;
  margin-top: 10px;
  padding: 0 15px;
}

.btns {
  margin: 20px 15px;
}

::v-deep {
  .van-cell-group--inset {
    margin: 0;
    border-top: 0;
  }
  .van-cell-group--inset::after {
    border: 0;
  }
  .van-cell {
    padding: 0;
    display: flex;
    align-items: center;
    height: 56px;
  }
  .van-cell::after {
    border-bottom: 1px solid #ebedf0;
    width: 315px;
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
  }
  .van-icon {
    color: #969799;
  }
}
</style>
